import { render } from "./plantPlasticSource.vue?vue&type=template&id=23b1c34e&scoped=true&ts=true"
import script from "./plantPlasticSource.vue?vue&type=script&lang=ts"
export * from "./plantPlasticSource.vue?vue&type=script&lang=ts"

import "./plantPlasticSource.vue?vue&type=style&index=0&id=23b1c34e&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b1c34e"]])

export default __exports__